import { event, payload } from '@conversa/reflex';

export const CompletedChatsTablePageUpdated = event(
  '[ component | CompletedChatsTable ] Page Updated',
  payload<{ page: number }>(),
);
